import React from "react"

function Table() {
    return (
        <div>
            <h2>We are in table</h2>
        </div>
    )
}

export default Table;